import { put, call, takeLatest } from "redux-saga/effects"

import {
    GET_SCREEN_DETAILS, UPDATE_SCREEN_DETAILS
} from "./actionTypes";
import {
    getScreenDetailsSuccess, getScreenDetailsFail, updateScreenDetailsSuccess, updateScreenDetailsFail
} from './actions';

import { getCall, postCall } from "../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

function* getScreenDetailsF(data) {
    try {
        let url = constClass.REST_API_GET_SCREEN_CANDIDATE_DATA + `?jobId=${data.payload.jobId}&candidateId=${data.payload.candidateId}`
        let responsJSON = yield call(getCall, decodeURIComponent(url))
        yield put(getScreenDetailsSuccess(responsJSON))
    }
    catch (error) {
        yield put(getScreenDetailsFail(error))
    }
}

function* updateScreenDetailsF({payload}) {
    try {
        let url = constClass.REST_API_GET_SCREEN_CANDIDATE_DATA
        yield call(postCall, url, payload)
        yield put(updateScreenDetailsSuccess("Details updated successfully"))
    }
    catch (error) {
        yield put(updateScreenDetailsFail(error))
    }
}

function* screenSaga() {
    yield takeLatest(GET_SCREEN_DETAILS, getScreenDetailsF)
    yield takeLatest(UPDATE_SCREEN_DETAILS, updateScreenDetailsF)
}

export default screenSaga